import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path
      d="M9 30V2m12 12c2.21 0 4-2.5 4-6s-1.79-6-4-6v28M13 2v6a4 4 0 11-8 0V2"
      fill="none"
    />
  </Icon>
);
